import React from 'react';
import { colorMap } from '../../../config/layerDictionary.js';
import './style/OverlayGroup.css';

const hiddenColorBox = ['Lotes do Projeto', 'Blocos de Entrega'];

const OverlayGroup = ({
  group,
  layers,
  expandedGroups,
  toggleGroup,
  checkedLayers,
  handleCheckboxEvent,
  expandedSubmenus,
  toggleSubmenu,
  loadingLayers
}) => {
  return (
    <div className="painel-grupo-overlay">
      <div className="painel-grupo-container">

        <div onClick={() => toggleGroup(group)} className="painel-grupo-titulo">
          {group}
          <span>{expandedGroups[group] ? '−' : '+'}</span>
        </div>

        {expandedGroups[group] && (
          <ul className="painel-lista-checkboxes">
            {layers.map(({ name, children }) => (
              <React.Fragment key={name}>
                <li className="painel-bloco-layer">
                  <div className="painel-label">
                    <div className="painel-label-service">
                      {children && (
                        <span
                          className="painel-subtoggle"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSubmenu(name);
                          }}
                        >
                          {expandedSubmenus[name] ? '−' : '+'}
                        </span>
                      )}
                      <span>{name}</span>
                    </div>
                    <input
                      type="checkbox"
                      className="painel-checkbox"
                      checked={checkedLayers[name] || false}
                      disabled={loadingLayers[name] || false}
                      onChange={(e) => handleCheckboxEvent(e, name)}
                    />
                  </div>
                </li>

                {children && expandedSubmenus[name] && (
                  <ul className="painel-subcheckboxes">
                    {children.map((sub) => (
                      <li key={`${name}::${sub.name}`}>
                        <label className="painel-label status-item">
                          <div className="status-label">
                            {colorMap[sub.name] && !hiddenColorBox.includes(sub.name) && (
                              <div
                                className="status-color-box"
                                style={{ backgroundColor: colorMap[sub.name] }}
                              />
                            )}
                            <span>{sub.name}</span>
                          </div>
                          <input
                            type="checkbox"
                            className="painel-checkbox"
                            checked={checkedLayers[`${name}::${sub.name}`] || false}
                            disabled={loadingLayers[`${name}::${sub.name}`] || false}
                            onChange={(e) => handleCheckboxEvent(e, `${name}::${sub.name}`, sub)}
                          />
                        </label>
                      </li>
                    ))}
                  </ul>
                )}
              </React.Fragment>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default OverlayGroup;